import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import {
  ARRIVAL_DATE_VARIABLE_SELECTOR,
  CUTOFF_TIME_VARIABLE_SELECTOR,
  INVENTORY_SNAPSHOT_VARIABLE_SELECTOR,
  KEY_METAFIELD_VARIABLE_SELECTOR,
  SHIPPING_RATE_VARIABLE_SELECTOR,
  SHIPPING_ZIPCODE_VARIABLE_SELECTOR,
  SHIP_DATE_VARIABLE_SELECTOR,
} from '../utils';

@Component({
  selector: 'plugin-preview-basic',
  templateUrl: './plugin-preview-basic.component.html',
  styleUrls: ['./plugin-preview-basic.component.scss'],
  standalone: false,
})
export class PluginPreviewBasicComponent implements OnInit, OnChanges {
  @Input() config: ShopPlugin.ProductPagePromise.Config;
  @Input() iconPreview: any = '';
  @Input() currencySymbol: string;
  @Input() themeEditorUrl?: string;
  DesignTemplate = ShopPlugin.ProductPagePromise.DesignTemplate;

  shipDateExample = 'shipping by Friday, Sep. 5';
  fastestTextPipeArg = [{ name: ARRIVAL_DATE_VARIABLE_SELECTOR, value: '<b>arrives by Friday, Sep. 5</b>' }];
  freeTextPipeArg = [{ name: ARRIVAL_DATE_VARIABLE_SELECTOR, value: '<b>arrives by Friday, Sep. 12</b>' }];
  inStockTextPipeArg = [{ name: SHIP_DATE_VARIABLE_SELECTOR, value: `<b>${this.shipDateExample}</b>` }];
  outOfStockTextPipeArg = [{ name: KEY_METAFIELD_VARIABLE_SELECTOR, value: `<b> 7 business days</b> ` }];
  partialStockTextPipeArg = [
    { name: KEY_METAFIELD_VARIABLE_SELECTOR, value: ` <b> 7 business days</b>` },
    { name: INVENTORY_SNAPSHOT_VARIABLE_SELECTOR, value: `<b>3</b> units are` },
    { name: SHIP_DATE_VARIABLE_SELECTOR, value: `<b>${this.shipDateExample}</b>` },
  ];
  zipCodeMinimalElement =
    'to <span style="white-space:nowrap"><u>051545</u><img src="/assets/icons/product-promise/arrow-down.svg" /></span>';
  zipCodeAvailableControl = new UntypedFormControl(true);
  variantAvailabilityControl = new UntypedFormControl('inStock');
  PluginType = ShopPlugin.ProductPagePromise.PluginType;
  constructor() {}

  ngOnInit() {
    this.fastestTextPipeArg.push({
      name: SHIPPING_RATE_VARIABLE_SELECTOR,
      value: this.config?.fastestShipping?.showPrice ? `<b>${this.currencySymbol}14.59</b>` : '',
    });
    [
      this.fastestTextPipeArg,
      this.inStockTextPipeArg,
      this.outOfStockTextPipeArg,
      this.partialStockTextPipeArg,
    ].forEach((args) =>
      args.push({
        name: SHIPPING_ZIPCODE_VARIABLE_SELECTOR,
        value: this.config?.design?.template === this.DesignTemplate.MINIMAL ? this.zipCodeMinimalElement : '',
      }),
    );
    this.fastestTextPipeArg.push({
      name: CUTOFF_TIME_VARIABLE_SELECTOR,
      value: this.config?.fastestShipping?.showCutOffTime ? '<b>2hrs 21mins</b>' : '',
    });
    this.freeTextPipeArg.push({
      name: CUTOFF_TIME_VARIABLE_SELECTOR,
      value: this.config?.cheapestShipping?.showCutOffTime ? '<b>2hrs 21mins</b>' : '',
    });
    console.log(`CUTOFF DEBUG: ngOnInit; ${JSON.stringify(this.fastestTextPipeArg)} `);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes?.config?.currentValue?.fastestShipping?.showPrice !==
      changes?.config?.previousValue?.fastestShipping?.showPrice
    ) {
      const rateVariable = this.fastestTextPipeArg.find(
        (variable) => variable.name === SHIPPING_RATE_VARIABLE_SELECTOR,
      );
      if (rateVariable) {
        rateVariable.value = this.config?.fastestShipping?.showPrice ? `<b>${this.currencySymbol}14.59</b>` : '';
      }
    }

    if (changes?.config?.currentValue?.design?.template !== changes?.config?.previousValue?.design?.template) {
      const zipVariable = this.fastestTextPipeArg.find(
        (variable) => variable.name === SHIPPING_ZIPCODE_VARIABLE_SELECTOR,
      );
      if (zipVariable) {
        zipVariable.value =
          this.config?.design?.template === this.DesignTemplate.MINIMAL ? this.zipCodeMinimalElement : '';
      }
    }

    if (
      changes?.config?.currentValue?.fastestShipping?.showCutOffTime !==
      changes?.config?.previousValue?.fastestShipping?.showCutOffTime
    ) {
      console.log(`CUTOFF DEBUG: ngOnChanges; before change; ${JSON.stringify(this.fastestTextPipeArg)}`);
      const cutoffVariable = this.fastestTextPipeArg.find(
        (variable) => variable.name === CUTOFF_TIME_VARIABLE_SELECTOR,
      );
      if (cutoffVariable) {
        cutoffVariable.value = this.config?.fastestShipping?.showCutOffTime ? '<b>2hrs 21mins</b>' : '';
      }
      console.log(`CUTOFF DEBUG: ngOnChanges; after change; ${JSON.stringify(this.fastestTextPipeArg)}`);
    }

    if (
      changes?.config?.currentValue?.cheapestShipping?.showCutOffTime !==
      changes?.config?.previousValue?.cheapestShipping?.showCutOffTime
    ) {
      console.log(`CUTOFF DEBUG: ngOnChanges; before change; ${JSON.stringify(this.freeTextPipeArg)}`);
      const cutoffVariable = this.freeTextPipeArg.find((variable) => variable.name === CUTOFF_TIME_VARIABLE_SELECTOR);
      if (cutoffVariable) {
        cutoffVariable.value = this.config?.cheapestShipping?.showCutOffTime ? '<b>2hrs 21mins</b>' : '';
      }
      console.log(`CUTOFF DEBUG: ngOnChanges; after change; ${JSON.stringify(this.fastestTextPipeArg)}`);
    }
  }
}
